import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'

import { configureGraphQLClient } from './plugins/graphql.ts'
import { PRIME_CONFIG, PrimeVue } from './plugins/primevue.ts'

import type { App } from 'vue'

// eslint-disable-next-line import/no-unassigned-import
import './assets/scss/global.css'

export { configureAuthApiUrl } from './services/api-client.ts'

export function installRevolugoDesignSystem(app: App) {
  app.directive('tooltip', Tooltip)
  app.use(ConfirmationService)
  app.use(ToastService)
  app.use(PrimeVue, PRIME_CONFIG)
  configureGraphQLClient(app)
}
